import { z } from 'zod';
import { IsoDateTimeSchema } from './common.js';
export const CreateLocationRequestSchema = z.object({
    name: z.string().min(1).max(200),
    timezone: z.string().min(1).max(64).optional(),
    address: z.string().max(500).optional(),
});
export const UpdateLocationRequestSchema = z.object({
    name: z.string().min(1).max(200),
    timezone: z.string().min(1).max(64),
    address: z.string().max(500).nullable(),
});
export const LocationSchema = z.object({
    id: z.string().min(1),
    organisationId: z.string().min(1),
    name: z.string().min(1),
    timezone: z.string().min(1),
    address: z.string().nullable(),
    createdAt: IsoDateTimeSchema,
});
//# sourceMappingURL=location.js.map